import { createAction, props } from '@ngrx/store';
import { MenuItem, CartTotals, MenuItemUpsert, ModifierDetail } from '@core/models';
import { HomeSingleProductFormValues } from '@features/home/domain';

export const CART_FIND = createAction('[Cart] Find');
export const CART_FIND_BY_ID_SUCCESS = createAction('[Cart] Find By Id Success', props<{ cart: MenuItem | null }>());

export const CART_FIND_SUCCESS = createAction('[Cart] Find Success', props<{ items: MenuItem[] }>());

export const CART_FAILED = createAction('[Cart] Failed', props<{ error: string }>());

export const CART_UPDATE = createAction('[Cart] Update');
export const CART_REMOVE = createAction('[Cart] Remove', props<{ idArticulo: string }>());

export const CART_UPDATE_STATE = createAction('[Cart] Update State', props<{ item: MenuItem }>());
export const CART_UPDATE_FORM = createAction('[Cart] Update Form', props<{ cartForm: MenuItem }>());
export const CART_RESET_STATE = createAction('[Cart] Reset state');

export const CART_FIND_TOTALS = createAction('[Cart] Find Totals')

export const CART_UPDATE_TOTALS = createAction('[Cart] Update Totals', props<{ cartTotals: CartTotals }>());

export const CART_RESET_FORM = createAction('[Cart] Reset Form')

export const CART_UPDATE_STOCK = createAction('[Cart] Update Stock', props<{ updateProduct: MenuItemUpsert }>());

export const CART_CLEAR = createAction('[Cart] Clear')

export const CART_UPDATE_STOCK_ALL = createAction('[Cart] Update Stock All', props<{ menuId?: string }>());

export const CART_PRODUCT_ORDER_PROCESS = createAction('[Cart] Single Product Process Order',props<{ formValues: HomeSingleProductFormValues, detailsWithQuantity: ModifierDetail[], detailsWithQuantityNoAdd: ModifierDetail[], isEditing: boolean }>());

export const CART_PRODUCT_ORDER_PROCESS_SUCCESS = createAction('[Cart] Single Product Process Order Success', props<{ item: MenuItem }>());

export const CART_PRODUCT_ORDER_PROCESS_FAILURE = createAction('[Cart] Single Product Process Order Failure', props<{ error: string }>());

export const CART_UPDATE_STOCK_ALL_SUCCESS = createAction('[Cart] Update Stock All Success', props<{ itemsUpdated: MenuItem[] }>());
